import React from 'react';
import HeroSection from '../components/services/HeroSection';
import Features from '../components/services/Features';
import Process from '../components/services/Process';
import Deliverables from '../components/services/Deliverables';
import CaseStudy from '../components/services/CaseStudy';
import FAQ from '../components/services/FAQ';
import CTA from '../components/services/CTA';

const Growth = () => {
    return (
        <>
            <HeroSection />
            <Features />
            <Process />
            <Deliverables />
            <CaseStudy />
            <FAQ />
            <CTA />
        </>
    )
}

export default Growth;